import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';
import { UserUtil } from '@/utils/user-utils';
import { loginApiObj } from './login';
import { AesUtil } from '@/utils/aes-util';
import Cookies from 'js-cookie';

const instance = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const noNeedTokenApi = [loginApiObj.AppLogin];

instance.interceptors.request.use(
  (config) => {
    noNeedTokenApi.forEach((item) => {
      // 需要加上token的接口
      if (!item.url.includes(config.url)) {
        config.headers.Authorization = UserUtil.getToken();
        // config.headers.roleIds = `'910900000001'`;
        // 加密
        // if (config.data) {
        //   config.data = AesUtil.encryptPassword(JSON.stringify(config.data));
        // }
      }
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    if (response) {
      // 解密
      // if (!response.request.responseURL.includes('queryResources')) {
      //   response.data = JSON.parse(AesUtil.decryptPassword(response.data));
      // }
      if (response.headers['content-disposition']) {
        response.data.contentDisposition =
          response.headers['content-disposition'];
      }
      let code = response?.data?.code,
        msg = response.data.msg || response.data.message;
      if (code === 500) {
        if (msg) {
          Message.error(msg);
        }
        return Promise.reject(msg);
      }

      if (code === '401' || code === 401) {
        if (msg) {
          let msgData = msg.replace('token过期', '访问超时，请重新登录')
          Message.error(msgData);
          UserUtil.removeToken();
          if (msg == 'token过期') {
            let cookieToken = Cookies.get('TOKEN');
            if (cookieToken)
              window.open('https://www.eppjet.com/portal-ui/#/pwd/login');
            else router.push('/login');
          }
          return;
        }
      }

      if (code === '403' || code === 403) {
        if (msg) {
          Message.error('当前操作没有权限');
          // UserUtil.removeToken();
          return;
        }
      }
      if (code === '416' || code === 416) {
        if (msg) {
          Message.error(msg);
          return;
        }
      }
      if (code === '10001' || code === 10001) {
        if (msg) {
          router.push('/login_loading');
          return;
        }
      }
      return Promise.resolve(response?.data);
    }
  },
  (error) => {
    Message.error('请求错误！');
    return Promise.reject(error);
  },
);

export function getHttpService(HttpRequest) {
  let httpObj = {};
  for (let [key, value] of Object.entries(HttpRequest)) {
    let { url, method } = value;
    httpObj[key] = (params, cb, config = {}) => {
      let requestParams = paramsHandleObj[method](params);
      let requestUrl = cb ? cb(url) : url;
      return new Promise((resolve, reject) => {
        instance[method](requestUrl, requestParams, config)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    };
  }
  return httpObj;
}

const paramsHandleObj = {
  get(params) {
    return { params };
  },
  post(params) {
    return params;
  },
  delete(params) {
    return { params };
  },
  put(params) {
    return params;
  },
};

export default instance;
